/*@ngInject*/
angular.module('gw-um-j2js', [])
    .run(function () {});

require('./admin/adminFunctionConstants');

require('./authorization/authorizationConstants');
require('./authorization/authorizationStatus');
require('./authorization/permissionAction');

require('./checklist/checkListItemSourceType');
require('./checklist/checkListItemSubType');
require('./checklist/checkListItemType');

require('./configuredfile/configuredFileAction');

require('./copyright/copyrightLicenseType');

require('./data/dataSetAction');
require('./data/dataSetType');

require('./file/mimeType');

require('./login/clientType');

require('./logo/logoType');

require('./mail/emailMessage');
require('./mail/emailMessageOriginator');
require('./mail/emailMessageStatus');
require('./mail/emailNotificationOption');

require('./organization/organizationStatus');
require('./organization/organizationSubType');
require('./organization/organizationType');
require('./organization/organizationAction');

require('./persistence/adapter/databaseDownloadSectionName');

require('./reminder/reminderStatus');

require('./report/displayType');

require('./role/roleType');

require('./rules/ruleAction');
require('./rules/ruleConditionType');
require('./rules/model/ruleEntryStatus');
require('./rules/model/ruleFlag');
require('./rules/model/type');

require('./underwriting/account/accountAction');
require('./underwriting/attachment/attachmentType');
require('./underwriting/custombutton/customButtonFunctionType');
require('./underwriting/custombutton/customButtonType');
require('./underwriting/externaldata/externalReportAction');
require('./underwriting/filter/filterCriterionDataType');
require('./underwriting/filter/filterCriterionUiType');
require('./underwriting/filter/filterType');
require('./underwriting/form/editableFieldLevel');
require('./underwriting/form/fieldType');
require('./underwriting/form/formTemplateReference');
require('./underwriting/form/formTemplateStatus');
require('./underwriting/form/formTemplateType');
require('./underwriting/form/fieldtemplatecomponent/displayConditionOperator');
require('./underwriting/form/fieldtemplatecomponent/fieldTemplateComponentSettingOwningClass');
require('./underwriting/form/fieldtemplatecomponent/inputType');
require('./underwriting/form/fieldtemplatecomponent/displayConditionLogicalOperator');
require('./underwriting/form/ui/javascriptApplicableExpressions');
require('./underwriting/form/ui/javascriptExpressionOperandType');
require('./underwriting/form/ui/javascriptExpressionType');
require('./underwriting/form/ui/uIFormTemplateAction');
require('./underwriting/form/ui/uIFormTriggerOperatorType');
require('./underwriting/navigation/navigationItemType');
require('./underwriting/notification/notificationPreferencesAction');
require('./underwriting/notification/notificationPreferencesType');
require('./underwriting/notification/notificationType');
require('./underwriting/notification/notificationType');
require('./underwriting/policy/policyAction');
require('./underwriting/policy/policyReinstatementStatus');
require('./underwriting/policy/policyStatus');
require('./underwriting/policy/policyTransition');
require('./underwriting/policy/cancellation/cancellationPendingStatus');
require('./underwriting/policy/cancellation/policyCancellationStatus');
require('./underwriting/policy/cancellation/action/policyCancellationAction');
require('./underwriting/policy/endorsement/endorsementStatus');
require('./underwriting/policy/endorsement/endorsementTransition');
require('./underwriting/policy/issuance/policyIssuanceConstants');
require('./underwriting/policy/issuance/action/policyIssuanceAction');
require('./underwriting/policy/rewrite/policyRewriteAction');
require('./underwriting/policy/rewrite/policyRewriteStatus');
require('./underwriting/policy/rewrite/policyRewriteTransition');
require('./underwriting/policyform/manuscriptEndorsementFormType');
require('./underwriting/product/productTemplateAction');
require('./underwriting/product/productTypes');
require('./underwriting/proposal/proposalAction');
require('./underwriting/proposal/proposalSendType');
require('./underwriting/proposal/sectionTemplateApplicabilityType');
require('./underwriting/proposal/sectionTemplateStatus');
require('./underwriting/proposal/sectionTemplateAction');
require('./underwriting/proposal/sectionType');
require('./underwriting/quote/quoteAction');
require('./underwriting/quote/quoteStatus');
require('./underwriting/quote/quoteTransition');
require('./underwriting/renewal/renewalStatus');
require('./underwriting/renewal/renewalTransition');
require('./underwriting/role/roleConstants');
require('./underwriting/scoring/scoringRuleActions');
require('./underwriting/staterate/stateRateStatus');
require('./underwriting/staterate/stateRateAction');
require('./underwriting/submission/agentQuoteStatus');
require('./underwriting/submission/cancellationStatusConstants');
require('./underwriting/submission/policyCancellationType');
require('./underwriting/submission/submissionAction');
require('./underwriting/submission/submissionCopyOptions');
require('./underwriting/submission/submissionFormsUpgradeMode');
require('./underwriting/submission/submissionMappingReason');
require('./underwriting/submission/submissionOriginator');
require('./underwriting/submission/submissionReferralStatus');
require('./underwriting/submission/submissionStatus');
require('./underwriting/submission/submissionTransactionType');
require('./underwriting/submission/submissionTransition');
require('./underwriting/submission/submissionUploadStatus');
require('./underwriting/submission/underwritingAutomationStatus');
require('./underwriting/submission/event/activityEventNotificationStatus');
require('./underwriting/submission/event/activityEventStatus');
require('./underwriting/submission/event/activityEventType');
require('./underwriting/submission/event/activityEventUserType');
require('./underwriting/submission/task/submissionTaskStatus');
require('./underwriting/widget/widgetType');


require('./user/defaultPreferenceAction');
require('./user/defaultPreferencesDataType');
require('./user/defaultPreferencesType');
require('./user/userAction');
require('./user/userLoginType');
require('./user/userManagementAction');
require('./user/userStatus');
require('./user/userType');
require('./user/userGroupAction');


require('./webservice/registerableResourceConstants');

module.exports = 'gw-um-j2js';
